<app-dialog-content>
  <img mat-card-image src="{{ data }}" alt="Foto da ocorrencia">
</app-dialog-content>
